import { Injectable, inject } from '@angular/core';
import { getStorage, ref, listAll, deleteObject, getBlob } from "@angular/fire/storage";
import { SettingsService } from './settings.service';
import opentype from 'opentype.js';
import { HttpClient } from '@angular/common/http';
import { CommentsService } from './comments.service';
import { NetworkConstants } from 'na-lib';
import { isDateTime } from 'na-lib';
import { getDownloadURL, getMetadata } from '@angular/fire/storage';
import { Observable, Subject } from 'rxjs';
import { deepCopy } from 'na-lib';
import { supportUrlStructure } from '../supportUrls';
import { doc, Firestore, getDoc, serverTimestamp, setDoc, Timestamp } from '@angular/fire/firestore';
import { AppCheckService } from './app-check.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  storage = getStorage();
  db = inject(Firestore)
  constructor( private settingsService: SettingsService,
    private commentsService : CommentsService,
    private http: HttpClient,
    private appCheckService: AppCheckService,
    ) { }
  insideFolders:any=[]
  folders: any=[]
  folder:any=[]
  items: any=[]

imageCover:any
  insideItems:any=[]
  allImageCovers:any={}
  workTaskItem = {}
  workTaskFolder= []
  workTaskItemAllValues$ : Subject<any> = new Subject<any>();

  private videoThumbVersions = new Map<string, number>();
  private videoThumbUnsubscribes: (() => void)[] = [];
  videoThumbReady$: Subject<string> = new Subject<string>();

  private imageThumbVersions = new Map<string, number>();
  private imageThumbUnsubscribes: (() => void)[] = [];
  imageThumbReady$: Subject<string> = new Subject<string>();

  getStorageContentOfContextId(ro:string){
    this.folders=[]
    this.folder=[]
    this.insideFolders=[]
    this.insideItems=[]
    const route = 'Contexts/' + this.settingsService.contextId$ + ro
    const listRef = ref(this.storage, route);

    listAll(listRef)
      .then((res) => {
        res.prefixes.forEach((folderRef) => {
          this.folder.push({folder:folderRef.name, reference:folderRef.fullPath})
          this.insideFolders.push({folder:folderRef.name, reference:folderRef.fullPath})
        });

        res.items.forEach(async (itemRef) => {

          await getDownloadURL(ref(this.storage, itemRef.fullPath))
            .then((url) => {
              this.folder.push({item:itemRef.name, reference:itemRef.fullPath,url: url})
              this.insideItems.push({name:itemRef.name, reference:itemRef.fullPath, url: url})
            })
            .catch((error) => {
            });

        });
      }).catch((error) => {
        console.log(error)
      });
      return this.folder
  }

  getStorageMediaOfContextId(route:string){
    this.folders=[]
    this.folder=[]
    this.insideFolders=[]
    this.insideItems=[]
    let baseFolder = `${NetworkConstants.COLLECTION_CONTEXTS}/${this.settingsService.contextId$}`
    const routeComplete = baseFolder + route
    const listRef = ref(this.storage, routeComplete);
    // return new Promise(async (resolve, reject) => {
    return new Observable<any[]> ((observer) => {
      listAll(listRef).then(async (res) => {
        const prefixes = res.prefixes.map((folderRef) => {
          this.folder.push({folder:folderRef.name, reference:folderRef.fullPath})
          this.insideFolders.push({folder:folderRef.name, reference:folderRef.fullPath})
          return {name:folderRef.name,folder:folderRef.name, reference:folderRef.fullPath}
        });

        const items = res.items.map( async(itemRef) => {
          const supportUrl = 'context:/' +route + itemRef.name
          const url = supportUrlStructure(supportUrl, '', this.settingsService.contextId$ )
          let fileRef = ref(this.storage, itemRef.fullPath)
          return getMetadata(fileRef).then((metadata) => {
            let item = {name:itemRef.name,item:itemRef.name, reference:itemRef.fullPath,url:url,  supportUrl: supportUrl, metadata:metadata, thumbnail: undefined}
            if(metadata.contentType?.startsWith('video')) {
              item.thumbnail = this.getVideoThumb(item) as any
            } else if(metadata.contentType?.startsWith('image')){
              item.thumbnail = this.getImageThumb(item) as any
            }
            this.folder.push({item:itemRef.name, reference:itemRef.fullPath,url:url,  supportUrl: supportUrl, metadata:metadata})
            this.insideItems.push({name:itemRef.name, reference:itemRef.fullPath, url:url, supportUrl: supportUrl, metadata:metadata})
            return item
          })
          .catch((error) => {
            // Uh-oh, an error occurred!
          });
        });
        observer.next([...prefixes, ...await Promise.all(items)])
      }).catch((error) => {
        console.log(error)
      });
      return this.folder
    })
  }

async getCdFonts(contextId: string): Promise<{ name: string, url: string, filename: string }[]> {
  const folderPath = `Contexts/${contextId}/fonts/`;
  const storageRef = ref(this.storage, folderPath);
  const fontsList: { name: string, url: string, filename: string }[] = [];

  try {
    const result = await listAll(storageRef);
    for (const itemRef of result.items) {
      const url = await getDownloadURL(itemRef);
      const filename = itemRef.name;

      // Download the font, extract the real name
      const fontBlob = await this.downloadFontBlob(url);
      const fontBuffer = await this.readAsArrayBuffer(fontBlob);
      const loadedFont = opentype.parse(fontBuffer);
      const actualFontName = loadedFont.names.fullName.en || filename;

      fontsList.push({
        name: actualFontName, // Real font name
        url: url, // Original URL
        filename: filename // Filename used for URL
      });
    }
  } catch (error) {
    console.error('Error fetching CD fonts', error);
  }

  return fontsList;
}


async getPassFonts(passId: string): Promise<{ name: string, url: string, filename: string }[]> {
  const folderPath = `passes/${passId}/`;
  const storageRef = ref(this.storage, folderPath);
  const fontsList: { name: string, url: string, filename: string }[] = [];

  try {
    const result = await listAll(storageRef);
    for (const itemRef of result.items) {
      if (itemRef.name.endsWith('.ttf') || itemRef.name.endsWith('.otf')) {
        const url = await getDownloadURL(itemRef);
        const filename = itemRef.name;

        // Download the font, extract the real name
        const fontBlob = await this.downloadFontBlob(url);
        const fontBuffer = await this.readAsArrayBuffer(fontBlob);
        const loadedFont = opentype.parse(fontBuffer);
        const actualFontName = loadedFont.names.fullName.en || filename;

        fontsList.push({
          name: actualFontName, // Real font name
          url: url, // Original URL
          filename: filename // Filename used for URL
        });
      }
    }
  } catch (error) {
    console.error('Error fetching Pass fonts', error);
  }

  return fontsList;
}

// Download font file as Blob
async downloadFontBlob(url: string): Promise<Blob> {
  const storageRef = ref(this.storage, url);
  return await getBlob(storageRef);
}

// Convert Blob to ArrayBuffer
async readAsArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}

  async deleteFont(filePath: string): Promise<void> {
    const storageRef = ref(this.storage, filePath);
    try {
      await deleteObject(storageRef);
      // console.log(`Deleted ${filePath} successfully`);
    } catch (error) {
      console.error('Error deleting font', error);
      throw error;
    }
  }

  async deleteImage(filePath: string): Promise<void> {
    const storageRef = ref(this.storage, filePath);
    try {
      await deleteObject(storageRef);
      // console.log(`Deleted ${filePath} successfully`);
    } catch (error) {
      console.error('Error deleting image', error);
      throw error;
    }
  }

  async deleteFile(filePath: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {

    const storageRef = ref(this.storage, filePath);
    try {
       deleteObject(storageRef).then( value => {
        resolve(true)
      });
    } catch (error) {
      reject(false)
      console.error('Error deleting image', error);
      throw error;
    }

    })
  }

  getStorageWorkTaskFolder(route, tridyId,key, hostname){
    let image = ''
   this.workTaskItem = []
   this.workTaskFolder = []
    const listRef = ref(this.storage, route);
    listAll(listRef)
      .then((res) => {
        res.prefixes.forEach((folderRef) => {
        });

        res.items.forEach(async (itemRef) => {
          let firebaseUrl = `https://${hostname}/v1/pass/${route}/`

          const fullName = itemRef?.name.split('.')
          const extension  = fullName[fullName.length-1]
          const name = fullName[0]

          if(itemRef.name.includes('WT-'+key) && itemRef.name == 'WT-'+ key + '.' +extension){//if(itemRef.name.includes(key)){
            firebaseUrl += itemRef.name
            image = firebaseUrl
            this.workTaskItem[key]=deepCopy({item:itemRef.name, reference:itemRef.fullPath,url: image})
            this.workTaskItemAllValues$.next(this.workTaskItem)
          }

          // await getDownloadURL(ref(this.storage, itemRef.fullPath))
          //   .then((url) => {
          //     this.workTaskItem[key]=deepCopy({item:itemRef.name, reference:itemRef.fullPath,url: url})
          //     this.workTaskItemAllValues$.next(this.workTaskItem)
          //   })
          //   .catch((error) => {});


        });
      }).catch((error) => {
        console.log(error)
      });
      return image
  }

  /**
   * Get thumbnail URL for video files.
   * Video thumbnails are generated in firebase and stored in Storage, /Media_thumbnails/ folder.
   */
  getVideoThumb(item: any): string {
    if (!item) return '';

    const originalUrl = item.url;
    if (!originalUrl) return '';

    // Check if this is in a Media folder
    if (!item.supportUrl || !item.supportUrl.includes('/Media/')) return originalUrl;

    const thumbSupportUrl = item.supportUrl.replace('/Media/', '/Media_thumbnails/')

    // Split filename and extension, replace video extension with .jpeg
    const lastDotIndex = thumbSupportUrl.lastIndexOf('.');
    const nameWithoutExt = thumbSupportUrl.substring(0, lastDotIndex);

    // Video thumbnails are saved as JPEG images with _200x200 suffix
    const thumbFileUrl = `${nameWithoutExt}_video_poster_200x200.jpg`;

    // Use supportUrlStructure to convert to actual download URL
    const contextId = this.settingsService.contextId$;
    let url = supportUrlStructure(thumbFileUrl, '', contextId);

    // Append cache-busting param when thumbnail becomes ready via Firestore listener
    const fileName = item.name || item.item;
    const version = this.videoThumbVersions.get(fileName);
    if (version) {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}v=${version}`;
    }
    return url;
  }

  /**
   * Get thumbnail URL for image files.
   * Image thumbnails are generated in firebase and stored in Storage, /Media_thumbnails/ folder.
   */
  getImageThumb(item: any): string {
    if (!item) return '';

    const originalUrl = item.url;
    if (!originalUrl) return '';

    // Check if this is in a Media folder
    if (!item.supportUrl || !item.supportUrl.includes('/Media/')) return originalUrl;

    const thumbSupportUrl = item.supportUrl.replace('/Media/', '/Media_thumbnails/')

    // Split filename and extension
    const lastDotIndex = thumbSupportUrl.lastIndexOf('.');
    const nameWithoutExt = thumbSupportUrl.substring(0, lastDotIndex);
    const extension = thumbSupportUrl.substring(lastDotIndex);

    // Build new filename with _200x200 suffix
    const thumbFileUrl = `${nameWithoutExt}_200x200${extension}`;

    // Use supportUrlStructure to convert to actual download URL
    const contextId = this.settingsService.contextId$;
    let url = supportUrlStructure(thumbFileUrl, '', contextId);

    // Append cache-busting param when thumbnail becomes ready via Firestore listener
    const fileName = item.name || item.item;
    const version = this.imageThumbVersions.get(fileName);
    if (version) {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}v=${version}`;
    }
    return url;
  }

  /**
   * Create a Firestore document in MediaUploads with status 'pending' for an uploaded image.
   * The backend will update the status to 'success' once the thumbnail is generated.
   */
  createImageUploadDoc(fileName: string, originalPath: string): void {
    const contextId = this.settingsService.contextId$;
    if (!contextId || !fileName) return;

    const docId = `${contextId}__${fileName}`;
    setDoc(doc(this.db, 'MediaUploads', docId),{
      fileName: fileName,
      originalPath: originalPath,
      thumbnailPath: null,
      status: 'pending',
      timeStamp: serverTimestamp(),
      expireAt: Timestamp.fromMillis(Date.now() + 10 * 60 * 1000)
    })

  }

  /**
   * Subscribe to Firestore MediaUploads documents for image files.
   * When the backend thumbnail generation finishes (status === 'success'),
   * updates the cache-busting version and emits on imageThumbReady$.
   */
  async watchImageThumbnails(files: any[]): Promise<void> {
    this.unsubscribeImageThumbnails();

    const contextId = this.settingsService.contextId$;
    if (!contextId) return;

    const imageFiles = files.filter(f => f.metadata?.contentType?.startsWith('image/'));

    for (const file of imageFiles) {
      const fileName = file.name || file.item;
      if (!fileName) continue;

      const docId = `${contextId}__${fileName}`;
      const docRef = doc(this.db, `MediaUploads/${docId}`);

      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        const data = {
          id: snapshot.id,
          ...snapshot.data()
        };
          if (!data) return;

          if (data['status'] === 'success') {
            const currentVersion = this.imageThumbVersions.get(fileName) || 0;
            this.imageThumbVersions.set(fileName, currentVersion + 1);
            this.imageThumbReady$.next(fileName);
            // sub.unsubscribe();
          } else if (data['status'] === 'error') {
            // sub.unsubscribe();
          }
        }

      // this.imageThumbUnsubscribes.push(() => sub.unsubscribe());
    }
  }

  /**
   * Unsubscribe from all active Firestore image thumbnail listeners.
   */
  unsubscribeImageThumbnails(): void {
    this.imageThumbUnsubscribes.forEach(unsub => unsub());
    this.imageThumbUnsubscribes = [];
  }

  async downloadFileFromStorage(file, url, name){
    this.commentsService.progressSpin.emit(true)
    const date = new Date()

    const token = await this.appCheckService.getToken();
    const headers: Record<string, string> = {};
    if (token) headers['X-Firebase-AppCheck'] = token;

    this.http.get(url, { responseType: 'blob', headers }).subscribe((response: Blob) => {
      const link = document.createElement('a');
      const blob = new Blob([response], { type: response.type });
      link.href = URL.createObjectURL(blob);
      link.download = `${ isDateTime(date)}_${name.replace(' ', '')}`;
      link.click();
      this.commentsService.progressSpin.emit(false)
    });
  }

  /**
   * Subscribe to Firestore MediaUploads documents for video files.
   * When the backend thumbnail generation finishes (status === 'success'),
   * updates the cache-busting version and emits on videoThumbReady$.
   */
  async watchVideoThumbnails(files: any[]): Promise<void> {
    this.unsubscribeVideoThumbnails();

    const contextId = this.settingsService.contextId$;
    if (!contextId) return;

    const videoFiles = files.filter(f => f.metadata?.contentType?.startsWith('video/'));

    for (const file of videoFiles) {
      const fileName = file.name || file.item;
      if (!fileName) continue;

      const docId = `${contextId}__${fileName}`;
      const docRef = doc(this.db, `MediaUploads/${docId}`);
      // const sub = docData(docRef).subscribe((data: any) => {

      const snapshot = await getDoc(docRef);

      if (snapshot.exists()) {
        const data = {
          id: snapshot.id,
          ...snapshot.data()
        };
          if (!data) return;

          if (data['status'] === 'success') {
            const currentVersion = this.videoThumbVersions.get(fileName) || 0;
            this.videoThumbVersions.set(fileName, currentVersion + 1);
            this.videoThumbReady$.next(fileName);
          } else if (data['status'] === 'error') {
          }
      }
    }
  }

  unsubscribeVideoThumbnails(): void {
    this.videoThumbUnsubscribes.forEach(unsub => unsub());
    this.videoThumbUnsubscribes = [];
  }

}
